import React, { useMemo } from "react";
import styles from "./ObjectList.module.scss";
import { useAppSelector } from "../../../../../../redux/store";
import { getProjectsFromCurrentObject } from "../../../../../../redux/reducers/ui/selectors/objectSelectors";
import { ObjectItem } from "./ObjectItem/ObjectItem";
import {
  getIsNoResultsFound,
  getIsSearching,
  getSearchProjects,
} from "../../../../../../redux/reducers/ui/selectors/searchSelectors";

interface IObjectListProps {
  sortValue: number;
}
export const ObjectList: React.FC<IObjectListProps> = props => {
  const { sortValue } = props;
  const projects = useAppSelector(getProjectsFromCurrentObject);
  const isSearching = useAppSelector(getIsSearching);
  const searchProjects = useAppSelector(getSearchProjects);
  const isNoResultsFound = useAppSelector(getIsNoResultsFound);

  const sortedProjects = useMemo(() => {
    const safeProjects = Array.isArray(projects) ? projects : [];
    return [...safeProjects].sort((a, b) => {
      if (sortValue === 0) {
        return a.name.localeCompare(b.name);
      } else if (sortValue === 1) {
        return b.name.localeCompare(a.name);
      }
      return 0;
    });
  }, [projects, sortValue]);

  const displayedProjects = isSearching ? searchProjects : sortedProjects;

  if (isNoResultsFound) {
    return (
      <div className={styles.not_found}>
        <div className={styles.text}>{"/// No results found ///"}</div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      {displayedProjects.length > 0 && (
        <div className={styles.list}>
          {displayedProjects.map((project, index) => (
            <ObjectItem key={index} project={project} />
          ))}
        </div>
      )}
    </div>
  );
};
